import { Button } from "primereact/button";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";


import { Toast } from "primereact/toast";

import { Card } from "primereact/card";
import { IVendorCompanyMast } from "../../../../../models/VendorCompanyMast";
import { ICityMastDropdown, IStateMastDropdown } from "../../../../../models/IDropdown";
import { ILogin } from "../../../../../models/Login";
import { Fetch } from "../../../../../shared/Fetch";
import { JVInput } from "../../../../../shared/JVInput";
import { JVInputMask } from "../../../../../shared/JVInputMask";
import { JVDropdown } from "../../../../../shared/JVDropdown";
import { JVDropdownInput } from "../../../../../shared/JVDropdownInput";


const schema = yup.object({
    vendor_Company_Name: yup.string().required("Company Name is required*").min(3),
    vendor_Company_FidNo: yup.string(),
    vendor_Company_Phone: yup.string().required("Phone No is required*"),
    vendor_Company_Phone1: yup.string(),
    vendor_Company_FaxNo: yup.string(),
    vendor_Type: yup.number().min(1, "Vendor Type is required*").required("Vendor Type is required*"),
    street_Address: yup.string().required("Street Address is required*"),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    // major_Technology: yup.string(),
    website_URL: yup.string().required().url()
});

interface IProps {
    open: boolean,
    singleData: any,
    reload: () => void,
    hideDialog: () => void,
    toast: any,
    reload1: boolean,
    setReload: (is: boolean) => void,
}

export const SubVendorCompanyDetails = (props: IProps) => {
    const [data, setData] = useState<IVendorCompanyMast>();
    const [loading, setLoading] = useState<boolean>(false);
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<IVendorCompanyMast>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const toast = useRef<any>(null);

    const getSubvendorDetails = async () => {
        const response = await Fetch("ResourceVendor_Company_Mast", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setData(data);
        }
    };

    const saveToDB = async (body: IVendorCompanyMast) => {
        setLoading(true);
        const method = "PUT";
        const message = "Updated Successfully";
        body.state_ID = body.state?.state_ID;
        body.city_ID = body.city?.city_ID;
        delete body.state;
        delete body.city;

        let newData: any = body;
        newData.contact_Person_ID = loginObj.sub_Vendor_ID;

        const response = await Fetch("ResourceVendor_Company_Mast", method, newData, null, toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            //  props.setReload(!props.reload);
            props.hideDialog();
            props.setReload(!props.reload1);
        }
        setLoading(false);
       // props.hideDialog();
    }


    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    };
    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    };

    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    };
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    };

    const onSubmit = (data: IVendorCompanyMast) => {
        // console.log(data);Aureon Consulting
        saveToDB(data);
    }
    const onHide = () => { };
    console.log(props.singleData.vendor_Company_Name)

    useEffect(() => {
        if (props?.singleData !== null && props?.singleData !== undefined) {
            let newData: any = props?.singleData;
console.log(props.singleData.vendor_Company_Name)
            newData.state = props?.singleData.state_ID ? {
                state_ID: props?.singleData.state_ID,
                state_Name: props?.singleData.state_Name
            } : props?.singleData.state;
            newData.city = props?.singleData.city_ID ? {
                city_ID: props?.singleData.city_ID,
                city_Name: props?.singleData.city_Name
            } : props?.singleData.city;
            newData.vendor_Type = 4;
            reset(newData);
        }
    }, [props?.singleData]);

    useEffect(() => {
    }, []);

    return (
        <>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid p-2">

                    <JVInput column={3} required label="Company Name" disabled control={control} name="vendor_Company_Name" error={errors.vendor_Company_Name?.message} />
                    <JVInput column={3} label="FID#" control={control} name="vendor_Company_FidNo" error={errors.vendor_Company_FidNo?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" required label="Phone No" control={control} name="vendor_Company_Phone" error={errors.vendor_Company_Phone?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" label="Alternate Phone No" control={control} name="vendor_Company_Phone1" error={errors.vendor_Company_Phone1?.message} />
                    <JVInput column={3} label="Fax No." control={control} name="vendor_Company_FaxNo" error={errors.vendor_Company_FaxNo?.message} />
                    {/* <JVDropdown column={3} required label="Company Type" control={control} name="vendor_Type" error={errors.vendor_Type?.message} options={[{ vendortypeid: 4, vendor_Type: "Sub Vendor" }]} optionLabel="vendor_Type" optionValue="vendortypeid" placeholder="Select Vendor Type" /> */}
                    <JVInput column={3} required label="Street Address" control={control} name="street_Address" error={errors.street_Address?.message} />

                    <JVDropdownInput column={3} required completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                    <JVDropdownInput column={3} required completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />

                    {/* <JVInput column={3} label="Major Technology" control={control} name="major_Technology" error={errors.major_Technology?.message} /> */}
                    <JVInput column={3} required disabled label="Website Url(http://www.domainname.com)" control={control} name="website_URL" error={errors.website_URL?.message} />
                    <div style={{ marginBottom: '20px', width: '100%' }}></div>

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                        <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                    </div>
                </form>
            </Card>
            <Toast ref={toast} />
        </>
    );
}